<template>
  <v-dialog v-model="dialog.show" max-width="520" persistent>
    <v-card>
      <v-card-title>{{ $t("ncrm.integrations.smtp.dialog.delete.title") }}</v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <p class="mb-3">
          {{
            $t("ncrm.integrations.smtp.dialog.delete.confirmText", {
              name: dialog.account?.name || "",
            })
          }}
        </p>
        <p class="text-caption text-medium-emphasis mb-3">
          {{ $t("ncrm.integrations.smtp.dialog.delete.confirmHint") }}
        </p>
        <v-text-field
          v-model="dialog.confirmation"
          :label="$t('ncrm.integrations.smtp.dialog.delete.confirmType')"
          autocomplete="off"
        />
        <v-alert v-if="dialog.error" type="error" class="mt-2">
          {{ dialog.error }}
        </v-alert>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" :disabled="dialog.deleting" @click="$emit('close')">
          {{ $t("ncrm.integrations.smtp.dialog.actions.cancel") }}
        </v-btn>
        <v-btn
          color="error"
          :loading="dialog.deleting"
          :disabled="dialog.confirmation !== 'DELETE'"
          @click="$emit('confirm')"
        >
          {{ $t("ncrm.integrations.smtp.dialog.actions.delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "NcrmCompanySmtpDeleteDialog",
  props: {
    dialog: {
      type: Object,
      required: true,
    },
  },
  emits: ["close", "confirm"],
};
</script>
